module.exports = __webpack_public_path__ + "static/media/S12_W.1f1ae965.png";